/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { LoosenRichTextFields } from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import { type Device, DeviceSchema } from './device'
import { type Image, ImageSchema } from './image'
import {
  type RelatedLinkApiProps,
  RelatedLinkApiPropsSchema,
} from './related-links-content'

export const BannerTextColor = {
  White: 'white',
  Black: 'black',
} as const

export type BannerTextColor =
  (typeof BannerTextColor)[keyof typeof BannerTextColor]

export type Banner = {
  textColor: BannerTextColor
  image: Image
  hiddenDevices: Device[]
  relatedLinks?: Maybe<RelatedLinkApiProps>
  titleSize?: Maybe<'medium' | 'large'>
}

/* Schemas */
export const BannerTextColorSchema = z.enum([
  BannerTextColor.White,
  BannerTextColor.Black,
])

export const BannerSchema = z.object({
  textColor: BannerTextColorSchema,
  image: ImageSchema,
  hiddenDevices: z.array(DeviceSchema),
  relatedLinks: z.nullish(RelatedLinkApiPropsSchema),
  titleSize: z.nullish(z.enum(['medium', 'large'])),
})

/* Schemas validation */
type TestBanner = ExpectTrue<
  Equal<LoosenRichTextFields<Banner>, z.infer<typeof BannerSchema>>
>
